import React from 'react';
import { useHistory } from 'react-router-dom';
import CapaLogoImg from './assets/CapaLogoImg.png';
import AppConfig from '@config';
import { localStorage, STORAGE_ACTION } from '@utils/storage';
import { colorSet } from '@components/Provider';
import { CustomizedButton } from '@components/Customized';
import GnbCheckerBoardMenu from '@routes/Common/CommonLayout/GnbCheckerBoardMenu';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      zIndex: 1000,
      backgroundColor: colorSet.gray000,
      position: 'fixed',
      borderBottom: `1px solid ${colorSet.gray400}`,
      top: 0,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 24px',
      height: 61,
      '& .logo': {
        zIndex: 1,
        cursor: 'pointer',
        width: 77,
        height: 20
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0px 16px',
        height: 49,
        '& .logo': {
          height: 18,
          width: 65
        }
      }
    },
    extraBtn: {
      display: 'flex',
      alignItems: 'center',
      color: colorSet.gray900,
      '& .gnb-join-partner': {
        color: colorSet.primary500,
        marginRight: 16
      },
      '& .gnb-login': {
        marginLeft: 20
      }
    }
  };
});

const RfqRequestPreviewHeaderPresenter: React.FC = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <img
        src={CapaLogoImg}
        alt="logo"
        className="logo"
        onClick={() => history.push('/')}
      />
      <div className={classes.extraBtn}>
        {!matches && (
          <>
            <CustomizedButton
              className="gnb-join-partner"
              variant="text"
              onClick={() => {
                window.location.href = AppConfig.partnersUrl as string;
              }}
            >
              제조 파트너 가입하기
            </CustomizedButton>
            <GnbCheckerBoardMenu />
          </>
        )}
        <CustomizedButton
          className="gnb-login"
          color="primary"
          variant="contained"
          size={matches ? 'small' : 'medium'}
          onClick={() => {
            localStorage.setItem(STORAGE_ACTION.REDIRECT_PATH, '/request');
            history.push('/login');
          }}
        >
          {matches ? '회원가입' : '로그인/회원가입'}
        </CustomizedButton>
      </div>
    </div>
  );
};

export default RfqRequestPreviewHeaderPresenter;
